import React, { createContext, useContext } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { FosterForm } from '@/components/fosters/fosterFormSchema'
import useFosterForm from '@/components/fosters/useFosterForm'

const FosterFormContext = createContext<UseFormReturn<FosterForm> | undefined>(
  undefined
)

export const useFosterFormContext = () => {
  const context = useContext(FosterFormContext)
  if (!context) {
    throw new Error(
      'useFosterFormContext must be used within a FosterFormProvider'
    )
  }
  return context
}

export const FosterFormProvider: React.FC<{
  children: React.ReactNode
  fosterId: string
}> = ({ children, fosterId }) => {
  const form = useFosterForm(fosterId)
  const { control, formState, setValue } = form
  return (
    <FosterFormContext.Provider
      value={{ ...form, control, formState, setValue }}
    >
      {children}
    </FosterFormContext.Provider>
  )
}
